import type React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getSelectedOfferFees } from 'selectors';

type RenderProps = { value: number; currency: string };

type Props = ConnectedProps<typeof connector> & {
  render: (params: RenderProps) => React.ReactElement<RenderProps>;
};

const SelectedOfferFeesComponent = ({ fees, render }: Props) => {
  const { value, currency } = fees;

  return render({ value, currency: currency as string });
};

const mapStateToProps = (state: RootState) => ({
  fees: getSelectedOfferFees(state),
});

const connector = connect(mapStateToProps);
const SelectedOfferFees = connector(SelectedOfferFeesComponent);

export { SelectedOfferFees };
